var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      { staticClass: "boss-table-data", attrs: { "data-test": "job-id" } },
      [_vm._v("\n    " + _vm._s(_vm.job.id) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data",
        attrs: { "data-test": "job-admin-name" },
      },
      [_vm._v("\n    " + _vm._s(_vm.job.adminName) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data left",
        attrs: { "data-test": "job-name" },
      },
      [_vm._v("\n    " + _vm._s(_vm.job.name) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data",
        attrs: { "data-test": "publish-date" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("formatDate")(_vm.job.startDate)) +
            " ~ " +
            _vm._s(_vm._f("formatDate")(_vm.job.endDate)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data",
        attrs: { "data-test": "publish-plan" },
      },
      [_vm._v("\n    " + _vm._s(_vm.job.plan) + "\n  ")]
    ),
    _vm._v(" "),
    _c("td", { staticClass: "boss-table-data" }, [
      _c("div", [
        _c(
          "button",
          {
            staticClass: "boss-button",
            attrs: { "data-test": "job-preview-button" },
            on: {
              click: function ($event) {
                return _vm.windowOpenPreview("jobPublishedPreview")
              },
            },
          },
          [_vm._v("\n        求人\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pega-mt-05" }, [
        _c(
          "button",
          {
            staticClass: "boss-button pega-width-5-5rem",
            attrs: { "data-test": "job-search-preview-button" },
            on: {
              click: function ($event) {
                return _vm.windowOpenPreview("jobSearchPublishedPreview")
              },
            },
          },
          [_vm._v("\n        検索一覧\n      ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.isPublishing
      ? _c("td", { staticClass: "boss-table-data" }, [
          _vm.job.isOriginalEntryForm
            ? _c(
                "span",
                { attrs: { "data-test": "job-original-entry-type" } },
                [_vm._v("専用応募フォーム")]
              )
            : _c(
                "select",
                {
                  staticClass: "boss-input-select js-check-default",
                  attrs: { "data-test": "job-entry-type" },
                  domProps: { value: _vm.job.isSimple },
                  on: { change: _vm.updateEntryType },
                },
                [
                  _c("option", { domProps: { value: true } }, [
                    _vm._v("\n        自己PR不要\n      "),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("\n        通常\n      "),
                  ]),
                ]
              ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }